import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

// Keep the API's Gregorian YYYY-MM-DD contract while displaying a Persian calendar.
export function toGregorianDateOnly(date) {
  if (!date) return "";
  const localDate = date.toDate();
  const year = localDate.getFullYear();
  const month = String(localDate.getMonth() + 1).padStart(2, "0");
  const day = String(localDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function DateOnlyInput({ label, value, onChange, name }) {
  const selectedDate = value ? new Date(`${value.slice(0, 10)}T00:00:00`) : null;
  const persianDate = selectedDate && !Number.isNaN(selectedDate.getTime())
    ? new DateObject(selectedDate).convert(persian, persian_fa)
    : null;

  return (
    <div className="flex flex-col gap-1 text-sm dark:text-white">
      {label && <label htmlFor={name} className="font-medium">{label}</label>}
      <DatePicker
        id={name}
        name={name}
        value={persianDate}
        onChange={(date) => onChange(toGregorianDateOnly(date))}
        calendar={persian}
        locale={persian_fa}
        format="YYYY/MM/DD"
        calendarPosition="bottom-right"
        inputClass="admin-field w-full"
        containerClassName="w-full"
        placeholder="تاریخ شمسی را انتخاب کنید"
      />
    </div>
  );
}
